import { useState, useCallback } from 'react';
import axios from 'axios';
import { useAlert } from './useAlert';

const API_URL = process.env.REACT_APP_API_URL;

export function useSettings() {
    const { showAlert } = useAlert();
    const [data, setData] = useState([]);

    const fetchData = useCallback(async () => {
        const res = await axios({
            method: 'GET',
            url: `${API_URL}/users/me`,
            withCredentials: true,
        })
        setData(res.data.data);
    }, []);

    const updateMe = useCallback(
        async ({ data, formData = false, preventDefaultEvent = false }) => {
            try {
                const res = await axios({
                    method: 'PATCH',
                    url: `${API_URL}/users/updateMe`,
                    withCredentials: true,
                    data,
                    headers: formData
                        ? { 'Content-Type': 'multipart/form-data' }
                        : undefined,
                }); 

                if (res.data.status === 'success') {
                    showAlert('Erfolgreich aktualisiert.', 'success');
                    setTimeout(() => window.location.reload(), 1000);
                }
            } catch (err) {
                showAlert('Fehler beim Aktualisieren der Daten.', 'error');
            }
        }, [showAlert]
    );

    const savePersonalData = useCallback(
        async (_e, personalDataChange) => {
            const { name, prename, partners, address, postCode, town, phoneNumber } = personalDataChange;
            await updateMe({ data: { name, prename, partners, address, postCode, town, phoneNumber } });
        }, [updateMe]
    );

    const saveCompanyData = useCallback(
        async (e, companyDataChange) => {
            const { companyName, website, bank, iban, bic, taxNumber, taxOffice, photo } = companyDataChange;

            const formData = new FormData();
            if (companyName) formData.append('companyName', companyName);
            if (website) formData.append('website', website);
            if (bank) formData.append('bank', bank);
            if (iban) formData.append('iban', iban);
            if (bic) formData.append('bic', bic);
            if (taxNumber) formData.append('taxNumber', taxNumber);
            if (taxOffice) formData.append('taxOffice', taxOffice);
            if (photo) formData.append('photo', photo);

            await updateMe({ data: formData, formData: true });
        }, [updateMe]
  );

    const saveCustomerData = useCallback(
        async (_e, customerNumberStart, customerStatusList) => {
            await updateMe({ data: { customerNumberStart, customerStatusList } });
        }, [updateMe]
    );

    const handlePasswordChange = async (passwordData) => {
        const { currentPassword, newPassword, confirmNewPassword } = passwordData;
        if(!currentPassword || !newPassword || !confirmNewPassword) {
            showAlert('Bitte alle Felder ausfüllen.', 'error');
            return;
        }
        if(newPassword !== confirmNewPassword) {
            showAlert('Die neuen Passwörter stimmen nicht überein.', 'error');
            return;
        }
        
        try {
            await axios({
                method: 'PATCH',
                url: `${API_URL}/users/updateMyPassword`,
                data: {
                    passwordCurrent: currentPassword,
                    password: newPassword,
                    passwordConfirm: confirmNewPassword
                },
                withCredentials: true
            });
            showAlert('Passwort erfolgreich geändert.', 'success');
        } catch (error) {
            showAlert('Fehler beim Ändern des Passworts.', 'error');
        }
    }

    return { fetchData, data, savePersonalData, saveCompanyData, saveCustomerData, handlePasswordChange };
}